import { render, staticRenderFns } from "./GeneralLiabilityInsurance.vue?vue&type=template&id=f9ad1ff2"
import script from "./GeneralLiabilityInsurance.vue?vue&type=script&lang=ts"
export * from "./GeneralLiabilityInsurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports